import { Badge } from '../ui/badge';
import { HelpCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { trackFAQClick } from '../../utils/analytics';

export function FAQSection({ content, theme, t }) {
  if (!content.faq?.items?.length) return null;

  return (
    <section key="faq" id="faq" data-section="faq" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <Badge className="bg-[#007a33] text-white border-[#007a33] mb-4 px-4 py-1 hover:bg-[#007a33] text-[0.7rem] font-black tracking-[1px]">
            {content.faq.badge || 'FAQ'}
          </Badge>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">{content.faq.title || 'Frequently Asked Questions'}</h2>
          <p className={`${t.textSecondary} text-lg`}>{content.faq.subtitle || 'Everything you need to know about Grassroots Coaching'}</p>
        </div>
        <Accordion type="single" collapsible className="space-y-4">
          {content.faq.items.map((item, index) => (
            <AccordionItem 
              key={item.id || index} 
              value={`faq-${index}`}
              className={`${t.faqBg} ${t.faqBorder} border rounded-xl px-6 ${t.faqOpenBorder}`}
            >
              <AccordionTrigger 
                className={`text-left ${t.text} hover:${t.accentText} hover:no-underline py-4`}
                onClick={() => trackFAQClick(index, item.question)}
              >
                <div className="flex items-center gap-3">
                  <HelpCircle className={`w-5 h-5 ${t.accentText} flex-shrink-0`} />
                  <span>{item.question}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className={`${t.textSecondary} pb-4 pl-8`}>
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
